
const menu = require('../../../../../components/menu/menu')
const dtHandler = require('../../../../../components/dt/dt-handler')


export function start(detail, htmlDt, htmlFc) {

  const menuElem = menuBody[detail.id]

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc)
  }

  detail.html = menuElem

  detail.act = 'show'
  menu.start(detail)

}


const menuBody = {

  trMenu: [

    {
      text: '',
      svg: 'eye',
      class: ``,
      dataDetail: ``,

      start: function (detail) {
        this.text = 'View/Edit'
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"item", "elem":"fullcont", "id":"item-fullcont", "act":"selectOne",  "entity":"item", "dbid": ${detail.dbid} }
           ]}'`

      }
    },

    {
      text: '',
      svg: 'report',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        let td = detail.ev.target;
        let tr = td.parentNode;
        let item_data = JSON.parse(tr.getAttribute('data-item'));

        this.text = 'Item Report'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"item", "elem":"page", "act":"removeReport", "pageId":"miDiv5"},
                              {"dest":"item", "elem":"report", "reportType":"reportOne", 
                              "entity":"item", "dbid":"${detail.dbid}", "item_name":"${item_data.item_name}",  "item_unit_id":"${item_data.item_unit_id}",
                              "item_unit_name":"${item_data.item_unit_name}", "source":"dt" } 

        ]}'`

      }

    },

    {
      text: '',
      svg: 'edit',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        let td = detail.ev.target;
        let tr = td.parentNode;
        let item_data = JSON.parse(tr.getAttribute('data-item'));
        //if exist one check
        this.class = ``
        this.text = `Update Selling Price`
        this.dataDetail = `data-detail='{
                            "click": [
                                {"dest":"ripple" },
                                {"dest":"menu", "act":"hide"},
                                {"dest":"item", "elem":"dt", "id":"item-dt", "act":"dialogUpdateSellingPrice", 
                                "dbid":"${detail.dbid}", "item_name":"${item_data.item_name}", "item_unit_id":"${item_data.item_unit_id}",
                                "item_unit_name":"${item_data.item_unit_name}" }  ]}'`
      }/**/
    },

    {
      text: '',
      svg: 'edit',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        let td = detail.ev.target;
        let tr = td.parentNode;
        let item_data = JSON.parse(tr.getAttribute('data-item'));
        //if exist one check
        this.class = ``
        this.text = `Add Lost Qty`
        this.dataDetail = `data-detail='{
                            "click": [
                                {"dest":"ripple" },
                                {"dest":"menu", "act":"hide"},
                                {"dest":"item", "elem":"fullcontLost", "id":"itemLost-fullcont", "act":"prepareAdd", 
                                "dbid":"${detail.dbid}", "item_name":"${item_data.item_name}", "item_unit_id":"${item_data.item_unit_id}",
                                "item_unit_name":"${item_data.item_unit_name}" }  ]}'`
      }/**/
    },

    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``,
      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}
        ]}'`,

      start: function (detail) {

        this.text = 'Delete'
        this.dataDetail = `data-detail='{
                            "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"item", "elem":"fullcont", "act":"deleteEntity", "entity":"item", "dbid":["${detail.dbid}"] } 
           ]}'`

      }
    },
  ],


  tableOptions: [

    {
      text: '',
      svg: 'report',
      class: ``, //same name as the title test

      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"},
                              {"dest":"item", "elem":"dt",  "act":"showAllItem" ,"entity":"item"} 

        ]}'`,


      start: function () {
        this.text = 'Show All Items'        //language.start('inProgress')     
      }
    },




    {
      text: '',
      svg: 'report',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        this.text = 'Inventory Report'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"item", "elem":"page", "act":"removeReport", "pageId":"miDiv5"},
                              {"dest":"item", "elem":"report", "reportType":"reportItemAvailable", "entity":"item"} 

        ]}'`

      }

    },

    {
      text: '',
      svg: 'report',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        this.text = 'Inventory Quantity Report'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"item", "elem":"page", "act":"removeReport", "pageId":"miDiv5"},
                              {"dest":"item", "elem":"report", "reportType":"reportItemQuantity", "entity":"item"} 

        ]}'`

      }

    },

    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``,
      dataDetail: ``,



      start: function (detail, htmlDt) {

        const ids = dtHandler.getTrChecked(htmlDt)

        //if exist one check
        if (ids.length > 0) {
          this.class = ``
          this.text = `Delete All (${ids.length})`
          this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"item", "elem":"fullcont", "act":"deleteEntity", "entity":"item",  "dbid":[${ids}]} ]}'`
        } else {
          this.class = `disabled`
          this.text = `Delete All`
          this.dataDetail = ''
        }/*if*/

      }/**/
    },
  ],


  fullcontOptions: [

    {
      text: '',
      svg: 'edit',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {
        this.text = `Edit`
        this.dataDetail = `data-detail='{
                                   "click": [
                                      {"dest":"ripple" },
                                      {"dest":"menu", "act":"hide"},
                                      {"dest":"item", "elem":"fullcont",  "id":"item-fullcont", "act":"prepareEdit" }  ]}'`
      }/**/
    },

    {
      text: '',
      svg: 'print',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        //if exist one check
        this.class = ``
        this.text = `Print`
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"item", "elem":"dt", "act":"trPrint"} ]}'`
      }/**/
    },


    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``, //same name as the title test

      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        const dbid = htmlFc.fullcontHTML.getAttribute('data-dbid')

        //if exist one check
        this.class = ``
        this.text = `Delete `
        this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"item", "elem":"fullcont", "act":"deleteEntity", "entity":"item",  "dbid":[${dbid}]} ]}'`

      }/**/
    },


  ],

}/*menuBody*/


